import React from 'react'
import { ComponentExt } from '@utils/reactExt'
import logo from "@assets/img/xiaotian/aoac_logo.png"
import * as styles from "./style/index.scss"

export default class XiaoTianTraffic extends ComponentExt<any, any> {
    state: { iccid: string; imei: string; monthUsage, surplusUsage, goodsReleaseName, endDate, hasGetObtainTerminalUsage, hasGetSimInfo }
    constructor(props) {
        super(props)
        this.state = {
            iccid: '',
            imei: '',
            monthUsage: '', //本月已使用
            surplusUsage: '', //剩余流量
            goodsReleaseName: '',
            endDate: '',
            hasGetObtainTerminalUsage: false,
            hasGetSimInfo: false
        }
    }

    /*
* 流量单位过滤器
* */
    filterFlowUnit(flow: number = 0, returnObj: boolean = false): any {
        const flowRes = { value: Number(flow) || 0, unit: 'KB' }
        let negative = false;
        if (flowRes.value < 0) {
            negative = true;
            flowRes.value = 0 - flowRes.value
        }
        switch (true) {
            case 0 < flowRes.value && flowRes.value < Math.pow(1024, 1):
                break
            case Math.pow(1024, 1) <= flowRes.value && flowRes.value < Math.pow(1024, 2):
                flowRes.value = flowRes.value / Math.pow(1024, 1)
                flowRes.unit = 'MB'
                break
            case Math.pow(1024, 2) <= flowRes.value && flowRes.value < Math.pow(1024, 3):
                flowRes.value = flowRes.value / Math.pow(1024, 2)
                flowRes.unit = 'GB'
                break
            case Math.pow(1024, 3) <= flowRes.value && flowRes.value < Math.pow(1024, 4):
                flowRes.value = flowRes.value / Math.pow(1024, 3)
                flowRes.unit = 'TB'
                break
            case Math.pow(1024, 4) <= flowRes.value:
                flowRes.value = flowRes.value / Math.pow(1024, 4)
                flowRes.unit = 'PB'
                break
            default:
                break
        }
        flowRes.value = !negative ? Number(flowRes.value.toFixed(3)) : 0 - Number(flowRes.value.toFixed(3))
        if (!returnObj) {
            return { value: flowRes.value, unit: flowRes.unit }
        }
        return flowRes
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份是从0开始的
        const day = date.getDate();
        return `${year}年${month}月${day}日`;
    }

    openAOAC = () => {
        if ((window as any).jsbridge) {
            (window as any).jsbridge.startSmallApp({
                appid: "202411191820335276",
                url: "https://aoac.lenovoconnect.com/index.html#/mobileXiaoTian",
                title: "懂的智联",
                width: "1440",
                height: "900",
                minwidth: "1152",
                minheight: "720",
                data: `{"iccid":"${this.state.iccid}","imei":"${this.state.imei}"}`
            })
        }

    }

    async componentDidMount() {
        document.title = '流量查询'

        if ((window as any).jsbridge) {
            try {
                //coreappsRequest32 调用32位程序的插件
                var sn = await (window as any).jsbridge.coreappsRequest('NEWPLUGIN_WIN32MBNPLUGIN_HELLO', '')
                if (sn && sn != ',') {
                    this.setState({
                        iccid: sn.split(',')[0],
                        imei: sn.split(',')[1],
                    })
                    const res = await this.api.getObtainTerminalUsage({
                        simId: sn.split(',')[0],
                        esim: "0"
                    })
                    if (res) {
                        this.setState({
                            surplusUsage: res.surplusUsage,
                            monthUsage: res.monthUsage,
                            hasGetObtainTerminalUsage: true
                        })
                    }
                    const simInfo = await this.api.getSimInfo({
                        simId: sn.split(',')[0],
                        esim: "0"
                    })

                    if (simInfo) {
                        this.setState({
                            goodsReleaseName: simInfo.goodsReleaseName,
                            endDate: simInfo.endDate,
                            hasGetSimInfo: true
                        })
                    }

                } else {
                    this.setState({
                        hasGetObtainTerminalUsage: true,
                        hasGetSimInfo: true
                    })
                }
            } catch (error) {
                this.setState({
                    hasGetObtainTerminalUsage: true,
                    hasGetSimInfo: true
                })
            }
        } else {
            this.setState({
                hasGetObtainTerminalUsage: true,
                hasGetSimInfo: true
            })
        }

    }
    render() {
        return (
            <>
                <div className={styles.Xiaotian} style={{ background: 'unset' }}>
                    {this.state.hasGetObtainTerminalUsage && this.state.hasGetSimInfo && (
                        <>
                            {((String(this.state.surplusUsage) && String(this.state.monthUsage)) || (this.state.goodsReleaseName && this.state.endDate)) && (
                                <div>
                                    <div className={styles.contentBuble}>
                                        好的，通过<span className={styles.AIserver} onClick={() => this.openAOAC()}>#懂的智联</span>为您查询到当前套餐为：
                                    </div>

                                    {String(this.state.surplusUsage) && String(this.state.monthUsage) && (
                                        <>
                                            <div className={styles.contentDetail}>
                                                <div className={styles.DetailText1}>
                                                    <div className={styles.DetailPoint}></div>
                                                </div>
                                                <div className={styles.DetailText2}>本月已使用：</div>
                                                <div className={styles.DetailText3}>
                                                    {this.state.monthUsage > 0 ? this.filterFlowUnit(this.state.monthUsage).value : 0}
                                                    {this.state.monthUsage > 0 ? this.filterFlowUnit(this.state.monthUsage).unit : 'GB'}
                                                </div>
                                            </div>
                                            <div className={styles.contentDetail}>
                                                <div className={styles.DetailText1}>
                                                    <div className={styles.DetailPoint}></div>
                                                </div>
                                                <div className={styles.DetailText2}>本月剩余：</div>
                                                <div className={styles.DetailText3}>
                                                    {this.state.surplusUsage > 0 ? this.filterFlowUnit(this.state.surplusUsage).value : 0}
                                                    {this.state.surplusUsage > 0 ? this.filterFlowUnit(this.state.surplusUsage).unit : 'GB'}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {this.state.goodsReleaseName && this.state.endDate && (
                                        <>
                                            <div className={styles.contentDetail}>
                                                <div className={styles.DetailText1}>
                                                    <div className={styles.DetailPoint}></div>
                                                </div>
                                                <div className={styles.DetailText2}>{this.state.goodsReleaseName}</div>
                                            </div>
                                            <div className={styles.contentDetail} >
                                                <div className={styles.DetailText1}>
                                                    <div className={styles.DetailPoint}></div>
                                                </div>
                                                <div className={styles.DetailText2}>
                                                    {this.formatDate(this.state.endDate) + '到期'}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div className={styles.contentBuble} style={{ marginTop: 12 }}>如需更多服务，请进入：</div>
                                </div>
                            )}
                            {(!(String(this.state.surplusUsage) && String(this.state.monthUsage)) && !(this.state.goodsReleaseName && this.state.endDate)) && (
                                <div className={styles.contentBuble}>抱歉，暂未查询到流量信息，已帮您找到相关服务，请选择：</div>
                            )}
                        </>
                    )}
                    {!(this.state.hasGetObtainTerminalUsage && this.state.hasGetSimInfo) && (
                        <>
                            <div className={styles.contentBuble}>
                                好的，正在通过<span className={styles.AIserver} onClick={() => this.openAOAC()}>#懂的智联</span>为您查询中...
                            </div>
                            <div className={styles.contentBuble} style={{ marginTop: 12 }}>如需更多服务，请进入：</div>
                        </>
                    )}
                    <div className={styles.aoacBox} >
                        <div className={styles.aoacBoxPic}>
                            <img src={logo} alt="" />
                        </div>
                        <div className={styles.aoacBoxTitle}>懂的智联</div>
                        <div className={styles.aoacBoxContent}>联想笔记本网络连接管理服务</div>
                        <div className={styles.aoacBoxSearch} onClick={() => this.openAOAC()}>查看</div>
                    </div>
                </div>


            </>
        )
    }
}
